import { companies } from '@debbie/cortex/dist/api/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import SearchInput from './SearchInput.js';
const CompanySearch = (props) => {
    const lang = useSelector((s) => s.lang);
    const searchAll = async (q) => {
        const result = await companies.search(q);
        return result
            ? result.map((company) => ({
                key: company.centralRegisterId,
                heading: company.name,
                subheading: `CVR: DK${company.centralRegisterId}`,
                small: company.status,
                returnData: company,
            }))
            : [];
    };
    return (React.createElement("div", { className: props.className },
        React.createElement(SearchInput, { disabled: props.disabled, autofocus: props.autofocus, static: props.value, onRemoveStatic: props.onRemoveStatic, placeholder: props.placeholder || lang.inputs.searchForCompany, searchAll: (q) => (q ? searchAll(q) : []), onSelect: props.onChange })));
};
export default CompanySearch;
//# sourceMappingURL=CompanySearch.js.map